import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
// import GridView from "./GridView";
import { useSearchParams } from "react-router-dom";
import PhoneAlphabet from "./PhoneAlphabet";
// import GridPhoneAlphabet from "./GridPhoneAlphabet";
import PhoneView from "./PhoneView";
import GridView from "./GridView";
import { useSwipeable } from "react-swipeable";
// import GridAlphabetScroll from "./GridAlphabetScroll";
// import Layout from '../Layout/Layout';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ height: "100%" }}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs(props: {
  //   page: number;
  //   pageSize: number;
  //   setPage: React.Dispatch<React.SetStateAction<number>>;
  //   setPageSize: React.Dispatch<React.SetStateAction<number>>;
  gridPage: number;
  gridPageSize: number;
  setGridPage: React.Dispatch<React.SetStateAction<number>>;
  setGridPageSize: React.Dispatch<React.SetStateAction<number>>;
  gridDataSize: number;
  setGridDataSize: React.Dispatch<React.SetStateAction<number>>;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
}) {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabFromURL = searchParams.get("tab");

  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setSearchParams({ tab: newValue.toString() });
  };

  React.useEffect(() => {
    if (tabFromURL && parseInt(tabFromURL) !== value) {
      setValue(parseInt(tabFromURL, 10));
    }
  }, [tabFromURL, value]);

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => {
      setValue((prev) => Math.min(prev + 1, 1));
      setSearchParams({ tab: Math.min(value + 1, 1).toString() });
    },
    onSwipedRight: () => {
      setValue((prev) => Math.max(prev - 1, 0)); 
      setSearchParams({ tab: Math.max(value - 1, 0).toString() });
    },
    trackMouse: true,
  });

  return (
    <Box sx={{ width: "100%", height: "100%" }} {...swipeHandlers}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="List" {...a11yProps(0)} />
          <Tab label="Grid" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <PhoneAlphabet />
        <PhoneView />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        {/* <GridAlphabetScroll /> */}
        <PhoneAlphabet />
        <GridView
          gridPageSize={props.gridPageSize}
          setGridDataSize={props.setGridPageSize}
          page={props.gridPage}
          setPage={props.setGridPage}
        />
      </CustomTabPanel>
    </Box>
  );
}
